import dynamic from "next/dynamic";
import * as React from "react";
// import AdminRefundPage from "../../src/Admin/AdminEditUserData/AdminRefund";
import { PageContainer } from "../../src/Basic/PageContainer";
import { TextContainer } from "../../src/Basic/TextContainer";
const AdminRefundPage = dynamic(
  () => import("../../src/Admin/AdminEditUserData/AdminRefundPage")
);
export default function RefundRoute() {
  return (
    // <AdminCheck>
    <PageContainer>
      <TextContainer maxWidth="sm">
        <AdminRefundPage></AdminRefundPage>
      </TextContainer>
    </PageContainer>
    // </AdminCheck>
  );
}
